import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecordWidgetComponent } from './record-widget.component';
import { MaterialModule } from '@app/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateFnsModule } from 'ngx-date-fns';

@NgModule({
  declarations: [RecordWidgetComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    DateFnsModule,
  ],
  exports: [RecordWidgetComponent],
})
export class RecordWidgetModule {}
